module.exports = __webpack_public_path__ + "img/server-error-light.150419c3.svg";